import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'upsc-demoformPage',
  templateUrl: './demoformPage.component.html',
  styleUrls: ['./demoformPage.component.scss']
})
export class DemoFormPageComponent implements OnInit {

  contactForm: UntypedFormGroup;
  
    constructor(
      private formBuilder: UntypedFormBuilder
    ) {
      this.contactForm = this.formBuilder.group({
        FirstName: ['', Validators.compose([Validators.required])],
        LastName: ['', Validators.compose([Validators.required])],
        CompanyName: ['', Validators.compose([Validators.required])],
        Country: ['', Validators.compose([Validators.required])]    
      });
    }
  
    ngOnInit(): void {
    }

    validateFormDetails() {
      console.log(this.contactForm.controls.FirstName.value);
    }
}